<template>
  <div>
    <button
      class="salesflow-btn salesflow-btn-small salesflow-btn-outline"
      @click="openModal()"
    >
      {{ __('Criar nova landing page') }}
    </button>
    <BModal
      id="modal-page-create"
      modal-class="modal-no-header-no-footer"
      ref="modal-page-create"
      hide-header="hide-header"
      hide-footer="hide-footer"
    >
      <template slot="default">
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="$refs['modal-page-create'].hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title align-items-center text-center">
          {{ __('Nova landing page') }}
          <h6 class="modal-subtitle">
            {{ __('Defina o nome da sua LP') }}
          </h6>
        </h4>
        <form
          class="px-20px"
          method="post"
          @submit.prevent="save()"
        >
          <div class="form-group">
            <label>{{ __('Título') }}</label>
            <input
              class="form-control"
              id="page-title"
              type="text"
              v-model="page.title"
              :placeholder="__('Utilizado para identificar sua LP dentro do Salesflow')"
              required="required"
            >
            <p
              class="form-text text-danger"
              v-if="errors['title']"
            >
              {{ errors['title'][0] }}
            </p>
          </div>
          <div class="modal-footer default-modal-footer">
            <button
              class="btn btn-primary f-w-600"
              type="submit"
              :disabled="saving"
            >
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="saving"
              /><span v-else>{{ __('Continuar') }}</span>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: {
    route: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      page: {
        title: null,
      },
      errors: [],
      saving: false,
    };
  },

  methods: {
    openModal () {
      this.$refs['modal-page-create'].show();

      setTimeout(() => document.querySelector('#page-title').focus(), 500);
    },

    save () {
      this.errors = [];
      this.saving = true;

      this.$http.post(this.route, this.page)
        .then(({ data }) => {
          window.location = `/page/${data.id}/template`;
        })
        .catch(({ data }) => {
          this.errors = data;
          this.saving = false;
        });
    },
  },
};
</script>
